import { useBreakpointValue } from '@chakra-ui/react';

import { useSettingsStore } from '../stores';

export const useLayoutUtils = () => {
  const { globalHeight: height, setGlobalHeight } = useSettingsStore(
    (store) => store,
  );

  const mdUp = useBreakpointValue({
    base: false,
    md: true,
    lg: true,
    xl: true,
    '2xl': true,
  });

  return { mdUp, innerHeight: height, setGlobalHeight };
};
